import { createContext } from 'react'

import type { AppConfig } from './types.d'

const AppConfigContext = createContext<AppConfig.Config>({})

export default AppConfigContext
